/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unit Converter — Length, Weight, Temperature & More | Toolverse`)
};

const es_uc_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de unidades — Longitud, Peso, Temperatura y Más | Toolverse`)
};

const de_uc_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einheitenumrechner — Länge, Gewicht, Temperatur & mehr | Toolverse`)
};

const nl_uc_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eenheidconverter — Lengte, Gewicht, Temperatuur & Meer | Toolverse`)
};

const fr_uc_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertisseur d'unités — Longueur, Poids, Température et plus | Toolverse`)
};

const it_uc_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertitore di unità — Lunghezza, Peso, Temperatura e altro | Toolverse`)
};

const pt_br2_uc_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de Unidades — Comprimento, Peso, Temperatura e Mais | Toolverse`)
};

const pt_uc_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de Unidades — Comprimento, Peso, Temperatura e Mais | Toolverse`)
};

const ja_uc_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユニットコンバーター — 長さ、質量、温度など | Toolverse`)
};

const zh_uc_hub_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_hub_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_hub_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_hub_meta_title", locale)
	if (locale === "en") return en_uc_hub_meta_title(inputs)
	if (locale === "es") return es_uc_hub_meta_title(inputs)
	if (locale === "de") return de_uc_hub_meta_title(inputs)
	if (locale === "nl") return nl_uc_hub_meta_title(inputs)
	if (locale === "fr") return fr_uc_hub_meta_title(inputs)
	if (locale === "it") return it_uc_hub_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_uc_hub_meta_title(inputs)
	if (locale === "pt") return pt_uc_hub_meta_title(inputs)
	if (locale === "ja") return ja_uc_hub_meta_title(inputs)
	return zh_uc_hub_meta_title(inputs)
};